document.addEventListener('DOMContentLoaded', () => {
  const abv = document.querySelector('#abv').innerText;
  const proofElement = document.querySelector('#proof');
  const proof = Number(abv) * 2;

  if (proof) {
    proofElement.textContent = `${proof} Proof`;
  }

  const previousLink = document.querySelector('#previous-link');
  const previousProduct = document.querySelector('#previous-product');
  const nextLink = document.querySelector('#next-link');
  const nextProduct = document.querySelector('#next-product');
  const postList = document.querySelector('.pagination-list');
  const current = postList.querySelector('.w--current').closest('div');

  let previousName =
    current.previousElementSibling?.querySelector('a').textContent;
  let previousURL = current.previousElementSibling
    ?.querySelector('a')
    .href.split('/products/')[1];

  let nextName = current.nextElementSibling?.querySelector('a').textContent;
  let nextURL = current.nextElementSibling
    ?.querySelector('a')
    .href.split('/products/')[1];

  if (!previousName || !previousURL) {
    previousName =
      current.parentElement?.lastChild.querySelector('a').textContent;
    previousURL = current.parentElement?.lastChild
      .querySelector('a')
      .href.split('/products/')[1];
  }

  if (!nextName || !nextURL) {
    nextName = current.parentElement?.firstChild.querySelector('a').textContent;
    nextURL = current.parentElement?.firstChild
      .querySelector('a')
      .href.split('/products/')[1];
  }

  if (previousName && previousURL) {
    previousLink.href = `/products/${previousURL}`;
    previousProduct.textContent = previousName;
  } else {
    previousLink.classList.add('visually-hidden');
  }

  if (nextName && nextURL) {
    nextLink.href = `/products/${nextURL}`;
    nextProduct.textContent = nextName;
  } else {
    nextLink.classList.add('visually-hidden');
  }

  const recipeCards = document.querySelector(
    '.product-recipes-container .product-recipes-list'
  );
  const body = document.querySelector('body');
  const recipeModals = document.querySelectorAll('.recipe-modal');

  let activeModal;

  recipeModals.forEach((modal) => {
    const close = modal.querySelector('.recipe-modal-close');
    close.addEventListener('click', closeModal);
  });

  function openModal(modal) {
    activeModal = modal;
    body.append(modal);
    modal.classList.add('show');
  }

  function closeModal() {
    const parent = document.querySelector(`[data-recipe="${activeModal.id}"]`);
    activeModal.classList.remove('show');
    parent.append(activeModal);
    body.classList.remove('modal-open');
    activeModal = null;
  }

  recipeCards.addEventListener('click', (e) => {
    let recipe = e.target.closest('.recipe-carousel-card')?.dataset?.recipe;
    if (!recipe) {
      recipe = e.target.querySelector('.recipe-carousel-card')?.dataset?.recipe;
    }
    const modal = recipeCards.querySelector(`#${recipe}`);
    if (!activeModal) {
      openModal(modal);
    }
  });

  const swiperTestimonials = new Swiper('.swiper.testimonials', {
    slidesPerView: 1,
    loop: true,
  });

  const swiperAttribution = new Swiper('.swiper.attribution', {
    slidesPerView: 1,
    loop: true,
    allowTouchMove: false,
  });

  swiperTestimonials.controller.control = swiperAttribution;

  const testimonialsPrev = document.querySelector(
    '.testimonial-button-previous'
  );
  const testimonialsNext = document.querySelector('.testimonial-button-next');

  testimonialsPrev.addEventListener('click', () => {
    swiperTestimonials.slidePrev();
  });

  testimonialsNext.addEventListener('click', () => {
    swiperTestimonials.slideNext();
  });
});
